import type { AppCookieConfig, CookieApp, CookieType, CookieTypeConfig, ScriptConfig } from '../types/cookies';
import { computed } from 'vue';
import {
	APP_COOKIE_CONFIG,
	COOKIE_TYPE_DEFAULTS,

} from '../types/cookies';

export function useCookieAppConfig(app: CookieApp) {
	const appConfig = computed<AppCookieConfig>(() => APP_COOKIE_CONFIG[app]);

	const availableTypes = computed(() =>
		Object.keys(appConfig.value.types ?? []) as CookieType[],
	);

	const getTypeConfig = (type: CookieType) =>
		computed<CookieTypeConfig | undefined>(() => {
			const cfg = appConfig.value.types[type];
			if (!cfg) {
				return undefined;
			}

			return {
				...cfg,
				type: cfg.type ?? COOKIE_TYPE_DEFAULTS[type].type,
				title: cfg.title ?? COOKIE_TYPE_DEFAULTS[type].title,
				description: cfg.description ?? COOKIE_TYPE_DEFAULTS[type].description,
				required: cfg.required ?? COOKIE_TYPE_DEFAULTS[type].required,
			};
		});

	return {
		appConfig,
		availableTypes,
		getTypeConfig,
		scripts: computed<Partial<Record<CookieType, ScriptConfig[]>>>(() => appConfig.value.scripts ?? {}),
	};
}
